export default "__VITE_ASSET__BbTf69QN__"